import React, { useState, useEffect, useRef } from "react";
import "./SearchJobsFilter.css";
import Pagination from "../../../Components/Pagination/Pagination";
import TeacherPageContainer from "../../Container/TeacherPageContainer";
import { connect } from "react-redux";
import { addRemoveFavouriteTeacher } from "../../../redux/college/college.actions";
import { API } from "../../../API";
import JobListingCard from "../../../Components/JobListingCard/JobListingCard";
import { getClassCategories, getCurrentPage } from "../../../Helper";
import SearchBar from "../../../Components/SearchBar/SearchBar";
import Spinner from "../../../Components/Spinner/Spinner";
import { filterJobCriterias } from "../utils";
import {
  fetchCampusData,
  fetchInstitutionData,
} from "../../../Helper/JobHelper";
import ArrowDropDownIcon from "@material-ui/icons/ArrowDropDown";
import ArrowDropUpIcon from "@material-ui/icons/ArrowDropUp";

const MyApplications = (props) => {
  const lazyCollegeData = useRef({});
  let [isLoaded, setIsLoaded] = useState(false);
  let [pageNum, setPageNum] = useState(1);
  let [allJobs, setAllJobs] = useState([]);
  let [showCurrentJobs, setShowCurrentJobs] = useState([]); // current page of results
  let [searchResults, setSearchResults] = useState([]); // all search results
  let [searchKeyword, setSearchKeyword] = useState("");
  let [searchLocation, setSearchLocation] = useState("");
  let [searchCategory, setSearchCategory] = useState("all");
  const [_englishCatExpanded, setEnglishCatExpanded] = useState(false);
  const [_vetCatExpanded, setVetCatExpanded] = useState(false);

  useEffect(() => {
    API.getMyApplications(props.user._id)
      .then(async ({ data: { listings } }) => {
        const sortedListings = listings.sort((a, b) => {
          return new Date(b.pub_date) - new Date(a.pub_date);
        });
        await fetchCampusData(sortedListings);
        setAllJobs(sortedListings);
        setSearchResults(sortedListings);
        handlePage(pageNum, sortedListings);
      })
      .catch((err) => {
        console.log(err.response);
        setIsLoaded(true);
      });
  }, []);

  // Show 10 users per page ------
  let handlePage = async (pageNumber, jobs) => {
    setIsLoaded(false);
    const jobList = getCurrentPage(pageNumber, jobs);
    await fetchInstitutionData(lazyCollegeData.current, jobList);
    setShowCurrentJobs(jobList);
    setPageNum(pageNumber);
    setIsLoaded(true);
  };

  const onPageNumChange = (e) => {
    // console.log(e.target.getAttribute("value"))
    handlePage(e.target.getAttribute("value"), searchResults);
  };

  const search = ({ keyword, category, location }) => {
    let kw = (keyword !== undefined ? keyword : searchKeyword).toLowerCase();
    let cat = (category !== undefined
      ? category
      : searchCategory
    ).toLowerCase();
    let catArr = [];
    switch (cat) {
      case "all":
        catArr = [];
        break;
      case "all-eng":
        catArr = categories.filter((c) => c.type === "eng").map((c) => c.value);
        break;
      case "all-vet":
        catArr = categories.filter((c) => c.type === "vet").map((c) => c.value);
        break;
      default:
        catArr = [cat];
        break;
    }
    let loc = (location !== undefined
      ? location
      : searchLocation
    ).toLowerCase();

    if (kw || cat || loc) {
      if (allJobs.length > 0) {
        let filteredJobs = allJobs.filter((job) => {
          let searchFilter = filterJobCriterias(job);
          let catMatch = false;
          for (let c of catArr) {
            if (searchFilter.category.includes(c)) catMatch = true;
          }
          if (!catArr.length) catMatch = true;
          return (
            searchFilter.keyword.includes(kw) &&
            catMatch &&
            searchFilter.location.includes(loc)
          );
        });
        handlePage(pageNum, filteredJobs);
        setSearchResults(filteredJobs);
      }
    } else {
      setSearchResults(allJobs);
      handlePage(pageNum, allJobs);
    }
  };

  const onSearchCategory = (e) => {
    let category = e.target.id;
    setSearchCategory(category);
    search({ category });
  };

  const onClickTag = (keyword) => {
    setSearchKeyword(keyword);
    search({ keyword });
  };

  const onChangeKeyword = (e) => {
    let keyword = e.target.value;
    setSearchKeyword(keyword);
    search({ keyword });
  };

  const onChangeLocation = (e) => {
    let location = e.target.value;
    setSearchLocation(location);
    search({ location });
  };

  const tabs = [
    {
      text: "Search Jobs",
      pathname: "/JobBoard",
    },
    {
      text: "Saved Jobs",
      pathname: "/SavedJobs",
    },
    {
      text: "My Applications",
      pathname: "/MyApplications",
      active: true,
    },
  ];

  const categories = getClassCategories();

  return (
    <TeacherPageContainer user={props.user} header="Job Board" tabs={tabs}>
      <div className="search-teacher-container">
        <div className="search-teacher-filters">
          <h2 className="search-teacher-subheading">Search by Keyword</h2>
          <div className="w-100 d-flex justify-content-center">
            <SearchBar
              placeholder="Type a keyword"
              onChange={onChangeKeyword}
              altColours
            />
          </div>
          <hr className="my-3" />
          <h2 className="search-teacher-subheading">
            Filter by Course Type/ Specialisation
          </h2>
          <h3
            className="search-teacher-subheading2 search-teacher-subheading-with-icon"
            onClick={onSearchCategory}
            style={{
              fontWeight: searchCategory === "all" ? "bold" : "normal",
              display: "block",
              cursor: "pointer",
            }}
            id="all"
          >
            Show All
          </h3>
          <div className="search-teacher-subheading-div">
            <h3 className="search-teacher-subheading2 search-teacher-subheading-with-icon">
              English (ELT)
            </h3>
            {_englishCatExpanded ? (
              <ArrowDropUpIcon
                className="search-category-arrow-icon"
                onClick={() => setEnglishCatExpanded((prevState) => !prevState)}
              />
            ) : (
              <ArrowDropDownIcon
                className="search-category-arrow-icon"
                onClick={() => setEnglishCatExpanded((prevState) => !prevState)}
              />
            )}
          </div>
          {_englishCatExpanded ? (
            <ul className="search-teacher-categories">
              <li
                id="all-eng"
                key="all-eng"
                onClick={onSearchCategory}
                style={{
                  fontWeight: searchCategory === "all-eng" ? "bold" : "normal",
                }}
              >
                Show All
              </li>
              {categories
                .filter((cat) => cat.type === "eng")
                .map((cat) => {
                  return (
                    <li
                      id={cat.value}
                      key={cat.value}
                      onClick={onSearchCategory}
                      style={{
                        fontWeight:
                          searchCategory === cat.value ? "bold" : "normal",
                      }}
                    >
                      {cat.name}
                    </li>
                  );
                })}
            </ul>
          ) : (
            ""
          )}
          <div className="search-teacher-subheading-div">
            <h3 className="search-teacher-subheading2 search-teacher-subheading-with-icon">
              Vocational (VET)/Digital & Tech
            </h3>
            {_vetCatExpanded ? (
              <ArrowDropUpIcon
                className="search-category-arrow-icon"
                onClick={() => setVetCatExpanded((prevState) => !prevState)}
              />
            ) : (
              <ArrowDropDownIcon
                className="search-category-arrow-icon"
                onClick={() => setVetCatExpanded((prevState) => !prevState)}
              />
            )}
          </div>
          {_vetCatExpanded ? (
            <ul className="search-teacher-categories">
              <li
                id="all-vet"
                key="all-vet"
                onClick={onSearchCategory}
                style={{
                  fontWeight: searchCategory === "all-vet" ? "bold" : "normal",
                }}
              >
                Show All
              </li>
              {categories
                .filter((cat) => cat.type === "vet")
                .map((cat) => {
                  return (
                    <li
                      id={cat.value}
                      key={cat.value}
                      onClick={onSearchCategory}
                      style={{
                        fontWeight:
                          searchCategory === cat.value ? "bold" : "normal",
                      }}
                    >
                      {cat.name}
                    </li>
                  );
                })}
            </ul>
          ) : (
            ""
          )}
          <hr className="my-3" />
          <h2 className="search-teacher-subheading">Search by Location</h2>
          <div className="w-100 d-flex justify-content-center">
            <SearchBar
              placeholder="Type city/region or 'online'"
              onChange={onChangeLocation}
              altColours
            />
          </div>
        </div>
        <div className="search-teacher-main">
          <h2 className="search-teacher-heading my-3">My Applications</h2>
          <div className="d-flex flex-wrap justify-content-center">
            {isLoaded ? (
              searchResults.length ? (
                showCurrentJobs.map((job) => {
                  return (
                    <JobListingCard
                      job={job}
                      onClickTag={onClickTag}
                      isApplied
                      isViewAsTeacher
                      myFavourites={props.user.my_favourites}
                    />
                  );
                })
              ) : (
                "No results found."
              )
            ) : (
              <Spinner small />
            )}
          </div>

          {searchResults.length ? (
            <Pagination
              itemArray={searchResults}
              pageNum={pageNum}
              onPageNumChange={onPageNumChange}
            />
          ) : null}
        </div>
      </div>
    </TeacherPageContainer>
  );
};

function mapStateToProps(state) {
  return {
    user: state.user.user,
  };
}

const mapDispatchToProps = {
  addRemoveFavouriteTeacher,
};

export default connect(mapStateToProps, mapDispatchToProps)(MyApplications);
